
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 52"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-stroke-colored":"true","stroke-width":"4","stroke-linecap":"round","d":"M6.671 5l5.657 5.657M12.329 5l-5.657 5.657"}}),_c('path',{attrs:{"d":"M22.843 7.86c1.125-2.133 4.18-2.133 5.306 0l4.606 8.73a3 3 0 002.142 1.555l9.724 1.683c2.377.411 3.32 3.317 1.64 5.047l-6.878 7.078a3 3 0 00-.819 2.518l1.405 9.769c.344 2.387-2.128 4.183-4.293 3.12l-8.856-4.356a3 3 0 00-2.648 0l-8.856 4.355c-2.164 1.064-4.636-.732-4.293-3.12l1.405-9.768a3 3 0 00-.818-2.518l-6.878-7.078c-1.682-1.73-.737-4.636 1.64-5.047l9.724-1.683a3 3 0 002.142-1.556l4.605-8.729z","stroke-width":"4","stroke-linejoin":"round","fill":"none"}}),_c('path',{attrs:{"d":"M43.5 11.829a2 2 0 11-4 0 2 2 0 014 0zm7 32.001a2 2 0 11-4 0 2 2 0 014 0zm-45-2a2 2 0 11-4 0 2 2 0 014 0z","data-fill-colored":"true"}})])
          )
        }
      }
    